<template lang="pug">
  v-row(justify="center")
    v-col(cols="auto")
      head-order-tab(
        :win-number-array="winNumberArray"
        :date="historyItem['closed_at']"
        :power-play="powerPlay"
      )
        template(#selection) 
          selection-round(
            v-model="roundId"
          )

    v-col(cols=12).px-5
      v-data-table(
        disable-sort
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalItem"
        :footer-props="footerProps"
      )
        template(#no-data)
          h3 {{ $t('no-content') }}
</template>
<script>
import HeadOrderTab from '../components/HeadOrderTab'
import { powerBall as apiPowerball } from '@/apis'
import SelectionRound from '../components/Selection/SelectionRound.vue'
export default {
  components: {
    HeadOrderTab,
    SelectionRound
  },
  props: {
    curItemRoomHistory: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    loading: false,
    historyItem: {},
    items: [],
    options: {
      page:1,
      itemsPerPage:15,
    },
    totalItem: -1,
    meta: {},
    winNumberArray: [],
    powerPlay:null,
    roundId: null
  }),
  computed: {
    footerProps () {
      return {
        "items-per-page-text": this.$t('row-per-page'),
        "disable-items-per-page": true,
        "show-current-page": true
      }
    },
    uuid () {
      return this.curItemRoomHistory.uuid
    },
    headers () {
      return [
        { text: this.$t('sequence'), value: 'sequence' },
        { text: 'Username', value: 'username', align: 'center' },
        { text: this.$t('power-ball.win-amount'), value: 'total_reward', align: 'end' }
      ]
    }
  },
  watch: {
    roundId () {
      this.load()
      this.loadResult()
    },
    options (val) {
      if(!this.options.page || !this.meta.page) return
      if(this.meta['current_page'] === this.options.page 
      && this.meta['item_per_page'] === this.options.itemsPerPage) {
        return
      }
      //map options from table to params 
      const params = {
        page: val.page,
        'item_per_page': val.itemsPerPage
      }
      this.load(params)
    }
  },
  mounted () {
    //set cur uuid room
    this.roundId = this.curItemRoomHistory.uuid
  },
  methods: {
    async load (params={}) {
      const id = this.roundId || this.uuid
      this.loading = true
      const [err, data,,meta] = 
        await apiPowerball.roomHistory.rannking.gets(id,params)
      this.loading = false
      if(err) return

      this.meta = meta
      this.options = {
        page: meta['current_page'],
        itemsPerPage: meta['item_per_page']
      }
      this.totalItem = meta['total_item_current_page']
      //auto sequence
      this.items = data.map((x,i)=>{
          x.sequence = (i+1) + ((meta['current_page']-1) * meta['item_per_page'])
          return x
      })
    },
    async loadResult (params = {}) {
      const id = this.roundId || this.uuid
      const [err, data,] = await apiPowerball.roomHistory.getById(id,params)
      if(err) return

      this.historyItem = data

      const winNumber = data['win_number']
      if(!winNumber) {
        this.winNumberArray = []
        this.powerPlay = null
        return
      }
      this.winNumberArray = [...winNumber['white_ball'], winNumber['power_ball']]
      this.powerPlay = winNumber['power_play']
    }
  }
}
</script>